import React, { CSSProperties, ReactNode } from "react";

type ContentProps = {
  flex?: boolean;
  children: ReactNode;
  scrollableContent?: boolean;
  disableContentPadding?: boolean;
};

const Content = ({
  children,
  flex,
  scrollableContent,
  disableContentPadding,
}: ContentProps) => {
  const style: CSSProperties = scrollableContent
    ? {
        position: "absolute",
        inset: 0,
        overflow: "auto",
        padding: disableContentPadding ? 0 : undefined,
      }
    : {
        position: "relative",
        padding: disableContentPadding ? 0 : undefined,
      };

  return (
    <div className={`content${flex ? " flex" : ""}`} style={style}>
      {children}
    </div>
  );
};

export default Content;
